import { Link } from '@heroui/react';

export function DemoSurveys({ surveys }) {
  return (
    <>
      {surveys.map((survey) => {
        const surveyName = survey.patientDisplayName;
        return (
          <Link
            className="block pb-1"
            key={survey.id}
            href={`/tracker/${survey.id}`}
          >
            {surveyName}
          </Link>
        );
      })}
    </>
  );
}
